import styled from '@emotion/styled';
import { theme } from 'styles/theme/theme';

export const CanvasWrapper = styled.div`
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: ${theme.zIndex.content};
  width: 100%;
  height: 100%;
`;
